// T131 — overlay z-index ladder (single source of truth). Higher tier renders
// above lower. Encodes the four de-facto tiers already in the codebase so they
// stop being magic numbers:
//   drawer  : right/left slide-overs that MODALS open on top of (SideDrawer)
//   modal   : the standard dialogs (cover letter, research, manual job, diff…)
//   overlay : page-level helper overlays above modals (toast history, mobile
//             nav, keyboard help)
//   dialog  : confirm/alert + command palette — always on top of everything
export const Z = {
  drawer: 'z-40',
  modal: 'z-50',
  overlay: 'z-[55]',
  dialog: 'z-[60]',
};
